module.exports = __webpack_public_path__ + "img/home-administration.d9994d19.svg";